export interface ProgressBarProps {
    progress: number; // 0-100
    label?: string;
    showPercentage?: boolean;
    variant?: 'default' | 'gradient';
    className?: string;
}

export function ProgressBar({
    progress,
    label,
    showPercentage = true,
    variant = 'default',
    className = '',
}: ProgressBarProps) {
    const clampedProgress = Math.min(Math.max(progress, 0), 100);

    return (
        <div className={`w-full ${className}`}>
            {(label || showPercentage) && (
                <div className="flex items-center justify-between mb-2">
                    {label && <span className="text-sm text-gray-300">{label}</span>}
                    {showPercentage && <span className="text-sm font-medium">{Math.round(clampedProgress)}%</span>}
                </div>
            )}

            <div className="w-full h-2 bg-gray-700 rounded-full overflow-hidden">
                <div
                    className={`h-full transition-all duration-300 ${variant === 'gradient'
                            ? 'bg-gradient-to-r from-primary-500 to-accent-500'
                            : 'bg-primary-600'
                        }`}
                    style={{ width: `${clampedProgress}%` }}
                />
            </div>
        </div>
    );
}
